import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faArrowDownToLine, faArrowUpToLine } from '@awesome.me/kit-2be97ecbd6/icons/sharp/solid';
import { DateTime } from 'luxon';
import clsx from 'clsx';

import styles from './TideStat.module.css';
import Placeholder from './Placeholder.jsx';
import DecimalValueFormat from './DecimalValueFormat.jsx';

const TIDE_TYPE_HIGH = 'high';
const TIDE_TYPE_LOW = 'low';

function TideStat({date, tides, units}) {
  const dateTime = date ? DateTime.fromISO(date) : undefined;
  return (
    <div className={styles.TideWrapper}>
      <div className={styles.DateBox}>
        <div className={styles.Date}>
          <Placeholder ready={dateTime} className={styles.DateDate} xs={6}>
            <div className={styles.DateDate}>{dateTime?.toFormat('dd')}</div>
          </Placeholder>
          <div className={styles.DateContext}>
            <Placeholder ready={dateTime} className={styles.DateDay} xs={8}>
              <div className={styles.DateDay}>{dateTime?.setLocale('en-AU').toLocaleString({weekday: 'short'})}</div>
            </Placeholder>
            <Placeholder ready={dateTime} className={styles.DateMonth} xs={8}>
              <div className={styles.DateMonth}>{dateTime?.setLocale('en-AU').toLocaleString({month: 'short'})}</div>
            </Placeholder>
          </div>
        </div>
      </div>
      <div className={styles.TideBox}>
        <div className={styles.Tides}>
          {tides != undefined && tides?.map((tide, index) => (
            <div key={index} className={clsx(styles.TideRow, tide.type == TIDE_TYPE_HIGH && styles.TideRowHigh) }>
              <div className={styles.TideTime}>{DateTime.fromISO(tide.timestamp)?.setLocale('en-AU').toLocaleString({hour12: false, hour: 'numeric', minute: 'numeric'})}</div>
              <div className={styles.TideHeight}>
                <DecimalValueFormat value={tide.value} />{units}
                <span className={styles.TideType}>
                  <OverlayTrigger
                    overlay={(props) =>
                      <Tooltip id={`tide-tooltip-${index}`}  {...props}>
                        {tide.type === TIDE_TYPE_LOW ? 'Low tide' : 'High tide'}
                      </Tooltip>
                    }
                  >
                    <FontAwesomeIcon icon={tide.type === TIDE_TYPE_LOW ? faArrowDownToLine : faArrowUpToLine} />
                  </OverlayTrigger>
                </span>
              </div>
            </div>
          ))}
          {!tides && Array.from({ length: 4 }, (_, index) => {
              return (
                <div key={index} className={styles.TideRow}>
                  <Placeholder className={styles.TideTime} xs={6} />
                  <Placeholder className={styles.TideHeight} xs={4} />
                </div>
              );
          })}
        </div>
      </div>
    </div>
  )
}

export default TideStat
